// Module
var code = "<div class=\"logo-circles left three\"></div> <div class=\"logo-circles left two\"></div> <div class=\"logo-circles left one\"></div> <div class=\"bz-waiting-logo\"></div> <div class=\"logo-circles right one\"></div> <div class=\"logo-circles right two\"></div> <div class=\"logo-circles right three\"></div> ";
// Exports
module.exports = code;